import HTTPResponse from '../utils/http/interfaces/HttpResponse';
import http from '../utils/http';
import httpVerbs from '../utils/http/httpVerbs';
import config, { getApiUrl } from '../utils/config';
import { getParameterizedUrl, getParameterizedUrlWith } from '@app/utils';
import { ServiceType } from '@app/types/ServiceType';

export const getUserPreference = async () => {
  try {
    const response = await http({
      method: httpVerbs.GET,
      url: getApiUrl(config.api[ServiceType.UserManagement].userPreference),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;  
  }
};

export const getUserPermission = async () => {
  try {
    const response = await http({
      method: httpVerbs.GET,
      url: getApiUrl(config.api[ServiceType.UserManagement].userPermissions),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getUserNavigationMenu = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api[ServiceType.UserManagement].userNavigationMenu),
  });
};

export const getUserDetails = (userId: string): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getParameterizedUrl(config.api[ServiceType.UserManagement].userById, userId),
  });
};

export const getUserRoles = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api[ServiceType.UserManagement].getUserRoles),
  });
};

//TODO: getUserGroups currently hardcoded will implemented in create user group
export const getUserGroups = (): Promise<HTTPResponse<any>> => {
  return Promise.resolve({
    status: 200,
    data: [
      { value: 1, name: 'Primary Admin Group' },
      { value: 2, name: 'Non Primary Admin Group' },
    ],
  });
};

export const getUserStatus = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api[ServiceType.UserManagement].getUserStatuses),
  });
};

export const getUserCount = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.HEAD,
    url: getApiUrl(config.api[ServiceType.UserManagement].getUserCount),
  });
};

export const createUser = (userData: any) => {
  return http({
    method: httpVerbs.POST,
    url: getApiUrl(config.api[ServiceType.UserManagement].createUser),
    data: userData,
  });
};

export const updateUser = (userId: string, data: any): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.PUT,
    url: getParameterizedUrl(config.api[ServiceType.UserManagement].userById, userId),
    data: data,
  });
};

export const loadUserDropdownData = (): Promise<any> => {
  return Promise.all([getUserRoles(), getUserStatus()]);
};

export const checkCrossUserExistence = (userEmail: any, contact = false) => {
  return http({
    method: httpVerbs.HEAD,
    url: getApiUrl(config.api[ServiceType.UserManagement].crossOrganizationUserExsistance),
    params: {
      email: userEmail,
      contact: contact,
    },
  });
};

export const checkCrossOrganizationUserExsistance = (userEmail: any, organizationId: string, contact = false) => {
  return http({
    method: httpVerbs.HEAD,
    url: getApiUrl(config.api[ServiceType.UserManagement].crossOrganizationUserExsistance),
    params: {
      email: userEmail,
      contact: contact,
      organizationId: organizationId,
    },
  });
};

export const requestResetPassword = (userData: any) => {
  return http({
    method: httpVerbs.PUT,
    url: getApiUrl(config.api[ServiceType.UserManagement].requestResetPassword),
    data: userData,
  });
};

export const getUserList = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api[ServiceType.UserManagement].getUserList),
  });
};

export const getContactsByClientId = (
  clientId: string, 
  page?: number, 
  pageSize?: number, 
  firstName?: string
): Promise<HTTPResponse<any>> => {
  const params: any = {};
  
  if (page !== undefined) {
    params.pageNumber = page;
  }
  if (pageSize !== undefined) {
    params.pageSize = pageSize;
  }
  if (firstName) {
    params.firstName = firstName;
  }
  
  return http({
    method: httpVerbs.GET,
    url: getParameterizedUrlWith(config.api[ServiceType.MasterData].contactsByClientId, [{name: 'clientId', value: clientId}]),
    params: Object.keys(params).length > 0 ? params : undefined,
  });
};

